import { FocusStyleManager } from "@blueprintjs/core";

FocusStyleManager.onlyShowFocusOnTabs();

export default FocusStyleManager;



// WEBPACK FOOTER //
// ./src/util/FocusManager.ts